import React, { memo } from 'react';
import ReactECharts from 'echarts-for-react';
import { generateClassName } from '../../../../../b2b-common/helpers';
import useSDGsImages from '../../hooks/useSDGsImages';

const SDGsImpact = memo(({ data, locale = 'es', size = 500, className = null }) => {

    const sdgColors = {
        1: '#E5243B',
        2: '#DDA63A',
        3: '#4C9F38',
        4: '#C5192D',
        5: '#FF3A21',
        6: '#26BDE2',
        7: '#FCC30B',
        8: '#A21942',
        9: '#FD6925',
        10: '#DD1367',
        11: '#FD9D24',
        12: '#BF8B2E',
        13: '#3F7E44',
        14: '#0A97D9',
        15: '#56C02B',
        16: '#00689D',
        17: '#19486A'
    };

    const { sdgImages } = useSDGsImages(locale);

    const getPieChartData = () => {
        const totalIndicators = data.reduce((sum, item) => sum + item.indicatorUUIDs.length, 0);
        return data.map(item => ({
            name: `SDG ${item.levelN_ItemId}`,
            value: ((item.indicatorUUIDs.length / totalIndicators) * 100).toFixed(2), // Calculate percentage
            itemStyle: {
                color: sdgColors[item.levelN_ItemId],
                borderColor: '#fff', // White border color
                borderWidth: 2 // Border width
            }
        }));
    };

    const options = {
        tooltip: {
            trigger: 'item',
            formatter: '{d}%' // Display percentage in tooltip
        },
        series: [
            {
                name: 'Indicators',
                type: 'pie',
                radius: ['50%', '85%'], // Inner and outer radius for donut chart
                center: ['50%', '50%'],
                padAngle: 2,
                itemStyle: {
                    borderRadius: 5
                },
                data: getPieChartData(),
                label: {
                    show: false // Hide labels
                },
                emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                }
            }
        ],
        graphic: {
            elements: [
                {
                    type: 'image',
                    id: 'sdgImage',
                    left: 'center',
                    top: 'center',
                    z: 100,
                    style: {
                        image: '',
                        width: size * 0.25,
                        height: size * 0.25,
                        opacity: 0
                    }
                }
            ]
        }
    };

    const onEvents = {
        'mouseover': (params) => {
            if (params.componentType === 'series' && sdgImages) {
                const sdgImage = sdgImages[params.data.name.split(' ')[1]]; // Get the SDG ID from the name
                options.graphic.elements[0].style.image = sdgImage;
                options.graphic.elements[0].style.opacity = 1;
                chartRef.current.getEchartsInstance().setOption(options);
            }
        },
        'mouseout': () => {
            options.graphic.elements[0].style.opacity = 0;
            chartRef.current.getEchartsInstance().setOption(options);
        }
    };

    const chartRef = React.useRef(null);

    return (
        <ReactECharts
            ref={chartRef}
            option={options}
            onEvents={onEvents}
            className={generateClassName('sdgs-impact-echart','', className)}
            style={{ height: `${size}px`, width: `${size}px` }}
        />
    );
});

SDGsImpact.displayName = 'SDGsImpact';

export default memo(SDGsImpact);